import { Modal, TableAction } from "App/Component/ui";
import { TableRow, TableCell } from "@material-ui/core";
import { useDatatables } from "App/hooks";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FreezeTableClient } from "components/organism";

const ModalBridge = ({ setShowModal, rowsBridge, formData, setFormData }) => {
  const handleClickSelect = (row) => {
    setFormData({
      ...formData,
      kj_bpjsbridge: row?.kodedokter,
    });
    setShowModal(false);
  };
  return (
    <Modal title={`Bridge`} width="60%" show={setShowModal}>
      <TableListBridge
        rows={rowsBridge}
        setShowModal={setShowModal}
        handleClickSelect={handleClickSelect}
      />
    </Modal>
  );
};

const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "kodedokter",
    disablePadding: true,
    label: "KODE DOKTER",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "namadokter",
    disablePadding: true,
    label: "NAMA DOKTER",
    align: "left",
    minWidth: "200px",
  },
];

const TableListBridge = ({ rows, handleClickSelect }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    setQ,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "",
    orderByRow: ["kodedokter", "namadokter"],
  });

  const additionData = {
    kodedokter: 1,
    namadokter: "Default",
  };
  const addedData = [additionData, ...data];

  return (
    <>
      <FreezeTableClient
        title="Daftar Kode Bridge BPJS"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={addedData}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {/* <TableRow hover>
          <TableCell scope="row" padding="none" align="center">
            0
          </TableCell>

          <TableCell scope="row" padding="none" align="center">
            <TableAction
              isUpdate={false}
              isDelete={false}
              isSelect={true}
              clickSelect={() =>
                handleClickSelect({
                  kodedokter: 1,
                })
              }
            />
          </TableCell>

          <TableCell align="left" width="20%">
            1
          </TableCell>
          <TableCell align="left">Default</TableCell>
        </TableRow> */}
        {stableSort(addedData, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow hover key={index}>
                <TableCell scope="row" padding="none" align="center">
                  {index + 1}
                </TableCell>
                <TableCell scope="row" padding="none" align="center">
                  <TableAction
                    isUpdate={false}
                    isDelete={false}
                    isSelect={true}
                    clickSelect={() => handleClickSelect(row)}
                  />
                </TableCell>

                <TableCell align="left" width="20%">
                  {row?.kodedokter}
                </TableCell>
                <TableCell align="left">{row?.namadokter}</TableCell>
              </TableRow>
            );
          })}
      </FreezeTableClient>
    </>
  );
};

export default ModalBridge;
